var map = {
	"./Carier_prices.svg": 2860,
	"./Credit_scoring.svg": 7476,
	"./Data_analytics.svg": 7926,
	"./E_learning.svg": 7725,
	"./E_learning_moodle.svg": 2985,
	"./Guantitative_synthesis.svg": 836,
	"./High_methane_gas.svg": 3017,
	"./Machine_learning.svg": 8489,
	"./PDF.svg": 7626,
	"./Pest_mold_incidence.svg": 854,
	"./Plot.svg": 7991,
	"./Trend_Prediction.svg": 6216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9235;